import React from "react";
import { WhatsappLogo, Lightning } from "@phosphor-icons/react";
import { WHATSAPP_NUMBER } from "../lib/api";

const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "¡Hola Ciudad Garaje! Quiero conocer la oferta de esta semana en NÉMESIS 🍺"
)}`;

const SCENE = "https://static.prod-images.emergentagent.com/jobs/f4d02145-fcf7-41ef-be94-47907979e0b0/images/4bd56022744e1907345a0a2cd3db7aa2ba2d1cb5e2e0b7f733dbfb7d074c9c73.jpeg";

export const NemesisBanner = () => (
  <section className="relative overflow-hidden bg-[#0b0707] border-y border-[#B3261E]/40" data-testid="nemesis-offer-banner">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(179,38,30,0.22),transparent_60%)]" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-12 md:py-16 flex flex-col md:flex-row items-center gap-10 md:gap-16">
      <img src={SCENE} alt="Némesis, la cerveza rebelde, en un garaje rockero" className="w-full md:w-[480px] aspect-[3/2] object-cover border border-[#B3261E]/50 shadow-2xl shadow-black/70" data-testid="nemesis-offer-image" />
      <div className="flex-1 max-w-xl text-center md:text-left">
        <div className="inline-flex items-center gap-2 bg-[#B3261E] text-white px-3 py-1.5 text-[11px] uppercase tracking-[0.2em] font-semibold" data-testid="nemesis-offer-badge">
          <Lightning size={14} weight="fill" /> Oferta de esta semana
        </div>
        <h2 className="font-display text-6xl md:text-8xl leading-none text-white mt-5" data-testid="nemesis-offer-title">
          NÉ<span className="text-[#E0574C]">MESIS</span>
        </h2>
        <p className="font-display text-2xl md:text-3xl text-[#f0d9c8] mt-2">Libre, irreverente… y en oferta</p>
        <p className="text-gray-300 text-sm md:text-base mt-5">
          Esta semana tenemos una oferta especial en la cerveza rebelde. <span className="text-white font-semibold">Escríbenos por WhatsApp y entérate de las ofertas.</span>
        </p>
        <a
          href={waUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 mt-8 px-7 py-3 bg-[#25D366] hover:bg-[#1ebe5b] text-black font-semibold uppercase tracking-wider text-sm transition-colors"
          data-testid="nemesis-offer-whatsapp"
        >
          <WhatsappLogo size={20} weight="fill" /> Escríbenos por WhatsApp
        </a>
      </div>
    </div>
  </section>
);
